<template>
  <BModal
    :model-value="modelValue"
    centered
    @update:modelValue="updateModal"
    content-class="custom-modal-content"
  > 
    <template #header>
      <h5 class="">{{ title }}</h5>
      <BButton variant="link" class="close" @click="updateModal(false)">
        <i class="ion ion-android-close"></i>
      </BButton>
    </template>

    <!-- Scroll hanya di bagian body -->
    <div class="custom-modal-body">
      <slot name="text"></slot>
      <slot name="body"></slot>
    </div>

    <template #footer>
      <div class="d-flex justify-content-end">
        <BButton
          variant="primary"
          @click="handleAction"
          class="mr-2"
          :disabled="loading"
        >
          {{ loading ? "Loading..." : "Yes" }}
        </BButton>
        <BButton variant="danger" @click="updateModal(false)">No</BButton>
      </div>
    </template>
  </BModal>
</template>
<script>
import { ref } from "vue";
import { BModal, BButton } from "bootstrap-vue-next";

export default {
  components: {
    BModal,
    BButton,
  },
  props: {
    title: String,
    modelValue: Boolean,
    modalConfirm: Boolean,
    uuid: String,
    data: Object,
    actionType: String,
    dataPriview: Object,
  },
  emits: ["update:modelValue", "confirmed"],
  setup(props, { emit }) {
    const loading = ref(false);

    const updateModal = (value) => {
      emit("update:modelValue", value);
    };

    const handleAction = async () => {
      loading.value = true;
      try {
        await emit("confirmed", {
          type: props.actionType,
          uuid: props.uuid,
          data: props.data,
        });
        updateModal(false);
      } catch (err) {
        console.error("Action failed", err);
      } finally { 
        loading.value = false;
      }
    };

    return {
      updateModal,
      handleAction,
      loading,
    };
  },
};
</script>

<style scoped>
.custom-modal-content {
  max-height: 100vh;
  display: flex;
  flex-direction: column;
}

.custom-modal-body {
  overflow-y: auto;
  padding: 1rem;
  max-height: 65vh;
}
</style>
